import http from 'hub-http/clients/apiClient';
const fetchContentAssistanceSettings = () => {
  return http.get(`content-assistance/v1/settings`);
};
export default fetchContentAssistanceSettings;